import {
  SurveyResults,
  SurveyResultsSchema,
} from "@/features/survey-results/survey-results-types";
import { Survey } from "@/features/surveys/survey-types";
import { Prompt, runStructuredPrompt } from "./LLMService";
import { getSettings } from "./SettingsService";

export async function answerSurveyLLM(survey: Survey): Promise<SurveyResults> {
  const prompt = makeGlobalPrompt(survey);
  const results = await runStructuredPrompt<SurveyResults>(
    prompt,
    SurveyResultsSchema
  );
  return results;
}

function makeGlobalPrompt(survey: Survey): Prompt {
  const settings = getSettings();
  const systemPrompt = settings.globalPrompt;
  const respondentFacingData = {
    surveyid: survey.id,
    questions: survey.questions,
    demographicTarget: survey.demographicTarget,
  };
  const userPrompt = `Here is the survey, answer it following the schema provided praviously: ${JSON.stringify(
    respondentFacingData
  )}`;
  return { systemPrompt, userPrompt };
}
